import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { resolveMedia } from "@/lib/api";
import { PageHero, Container, Reveal, SectionHeading, PHOTOS, CtaBand } from "@/components/public/parts";
import { CheckCircle2 } from "lucide-react";

const TEAM = [
  { name: "Yolanda Murphy", role: "Founder & Executive Director" },
  { name: "Care Coordination Team", role: "Service Planning" },
  { name: "Direct Support Professionals", role: "Daily Support" },
  { name: "Transportation Team", role: "Accessible Rides" },
];

export default function About() {
  const data = usePublicData();
  const s = data?.settings || {};
  const page = (data?.pages || {}).about || {};
  const img = (k, fb) => resolveMedia((data?.sections || {})[k]?.image_url || fb);
  return (
    <>
      <Seo title={page.seo_title || "About Love For Mankind"} description={page.meta_description} path="/about" />
      <PageHero eyebrow="Our Story" title={page.h1 || "About Love For Mankind"} sub="Advocating for equality, dignity and belonging across Ohio." breadcrumbs={[{ label: "Home", to: "/" }, { label: "About" }]} image={PHOTOS.community} />
      <Container className="py-16 lg:py-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal className="rounded-[2rem] overflow-hidden aspect-[4/3]"><img src={img("about", PHOTOS.community)} alt="Love For Mankind community" className="w-full h-full object-cover" /></Reveal>
        <Reveal delay={0.1}>
          <SectionHeading eyebrow="Our Mission" title="Care rooted in equality and respect" />
          <p className="text-[17px] text-muted-foreground mt-5 leading-[1.75]">{s.mission}</p>
          <ul className="mt-6 space-y-3.5">
            {["Person-centered plans for every individual", "Compassionate, trained caregivers", "Advocacy for those who need it most", "Deep roots in Ohio communities"].map((t) => (
              <li key={t} className="flex items-center gap-3 text-[17px]"><CheckCircle2 className="w-5 h-5 text-primary shrink-0" /> {t}</li>
            ))}
          </ul>
        </Reveal>
      </Container>
      <section className="bg-card border-y border-border">
        <Container className="py-16 lg:py-24">
          <Reveal><SectionHeading eyebrow="Our People" title="A team that leads with heart" gold /></Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {TEAM.map((m, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className="rounded-2xl border border-border bg-background p-6 text-center">
                  <div className="w-20 h-20 rounded-full bg-primary text-primary-foreground font-heading text-2xl font-bold flex items-center justify-center mx-auto">{m.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</div>
                  <p className="font-heading font-semibold mt-4">{m.name}</p>
                  <p className="text-sm text-muted-foreground">{m.role}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="text-center text-xs text-muted-foreground mt-8">Team profiles are managed through the LFM Media Library & CMS. Portraits will be added as approved.</p>
        </Container>
      </section>
      <CtaBand />
    </>
  );
}
